"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _url_utils = require("../../../lib/url_utils");
var _gmap_utils = _interopRequireDefault(require("../../../lib/gmap_utils"));
var _lodash = require("lodash");
var _apiListingsSearch = _interopRequireDefault(require("../../../api/api-listings-search"));
var _sharedIntlProviderHOC = _interopRequireDefault(require("../shared-components/hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var withSearchSubmitHoc = function withSearchSubmitHoc(WrappedComponent, heroHomePageProps) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);
    function HOC(props) {
      var _this;
      _classCallCheck(this, HOC);
      _this = _callSuper(this, HOC, [props]);
      _this.dropdownRefs = _this.dropdownRefs.bind(_assertThisInitialized(_this));
      _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
      _this.submitFormCb = _this.submitFormCb.bind(_assertThisInitialized(_this));
      _this.autoComplete = _this.autoComplete.bind(_assertThisInitialized(_this));
      _this.doAutoComplete = _this.doAutoComplete.bind(_assertThisInitialized(_this));
      _this.stringLocation = _this.stringLocation.bind(_assertThisInitialized(_this));
      _this.state = {
        predictions: []
      };
      return _this;
    }
    _createClass(HOC, [{
      key: "autoComplete",
      value: function autoComplete(input, callback) {
        var _this2 = this;
        if (!input) return null;
        var completer = _gmap_utils.default.autoCompleteService();
        var options = {
          input: input,
          types: ['geocode']
        };
        return completer.getPlacePredictions(options, function (predictions, status) {
          if ('ZERO_RESULTS' === status) {
            _this2.locationRef.toggleDropdown();
          }
          if ('OK' === status) {
            _this2.setState({
              predictions: predictions
            }, function () {
              if (callback) {
                callback();
              }
            });
          }
        });
      }
    }, {
      key: "stringLocation",
      value: function stringLocation(callback) {
        var _this3 = this;
        var _get = (0, _lodash.get)(this.state, 'predictions.0'),
          placeId = _get.place_id,
          description = _get.description;
        _gmap_utils.default.doAutoComplete(placeId, description, function (respObj) {
          var error = respObj.error,
            _respObj$queryObj = respObj.queryObj,
            queryObj = _respObj$queryObj === void 0 ? {} : _respObj$queryObj;
          if (error) return _this3.locationRef.toggleDropdown();
          return _apiListingsSearch.default.get(queryObj, null, function (listings, response) {
            // sometimes "response" returned by search API is not an object
            var bbox = _.get(response, 'suggested_viewport_bbox');
            var newQueryObject = bbox ? _.assign({}, queryObj, {
              viewport_bbox: "[".concat([bbox], "]")
            }) : queryObj;
            callback(JSON.stringify(newQueryObject));
          });
        });
      }
    }, {
      key: "doAutoComplete",
      value: function doAutoComplete(callback) {
        var _this4 = this;
        var _get2 = (0, _lodash.get)(this.state, 'predictions.0'),
          placeId = _get2.place_id,
          description = _get2.description;
        _gmap_utils.default.doAutoComplete(placeId, description, function (respObj) {
          var error = respObj.error,
            _respObj$queryObj2 = respObj.queryObj,
            queryObj = _respObj$queryObj2 === void 0 ? {} : _respObj$queryObj2;
          if (error) return _this4.locationRef.toggleDropdown();
          return _apiListingsSearch.default.get(queryObj, null, function (listings, response) {
            // sometimes "response" returned by search API is not an object
            var bbox = _.get(response, 'suggested_viewport_bbox');
            var newQueryObject = bbox ? _.assign({}, queryObj, {
              viewport_bbox: "[".concat([bbox], "]")
            }) : queryObj;
            callback(JSON.stringify(newQueryObject));
          });
        });
      }
    }, {
      key: "submitForm",
      value: function submitForm(element, callback, refs, value) {
        var _this5 = this;
        var activity = value.activity,
          location = value.location,
          dateTime = value.dateTime;
        if (!activity) {
          var activityInput = (0, _lodash.get)(this, 'activityInputRef.target');
          if (activityInput) {
            activityInput.focus();
            return callback();
          }
        }
        if (!location) {
          var locationInputValue = document.getElementById('search-location-input').value;
          if (locationInputValue && !dateTime) {
            return this.autoComplete(locationInputValue, function () {
              return _this5.stringLocation(function (jsonLocation) {
                return callback(activity, jsonLocation, dateTime);
              });
            });
          }
          if (locationInputValue && dateTime) {
            return this.autoComplete(locationInputValue, function () {
              return _this5.doAutoComplete(function (jsonLocation) {
                return callback(activity, jsonLocation, dateTime);
              });
            });
          }
          document.getElementById('search-location-input').focus();
          return callback();
        }
        return callback(activity, location, dateTime);
      }
    }, {
      key: "submitFormCb",
      value: function submitFormCb(activity, location, dateTime) {
        if (!activity) return;
        if (!location) return;
        var parsedLocation = JSON.parse(location);
        var spaceTypePage = document.getElementById('landing-page-components');
        var locale = _sharedIntlProviderHOC.default.getUrlPrefix();
        var localePrefix = locale ? "/".concat(locale) : '';
        if (parsedLocation.hasOwnProperty('loc_code')) {
          var locCode = parsedLocation.loc_code,
            _parsedLocation$map_c = parsedLocation.map_center,
            mapCenter = _parsedLocation$map_c === void 0 ? {} : _parsedLocation$map_c;
          var latitude = mapCenter.latitude,
            longitude = mapCenter.longitude;
          var _latLngDateTime = dateTime ? "&availability_interval=".concat(latitude, ",").concat(longitude, ",").concat(dateTime) : '';
          var createSearchLoc = locCode.toLowerCase().replace(/\,\s/g, '--').replace(/ /g, '-');
          var p1String = "".concat(createSearchLoc, "/?a=").concat(activity).concat(_latLngDateTime);
          window.location.href = "".concat(localePrefix, "/s/").concat(p1String).concat(spaceTypePage ? '&gs=1' : '');
          return null;
        }
        var filterText = (0, _lodash.get)(this.props, 'searchFormProps.filterText');
        var filterType = (0, _lodash.get)(this.props, 'searchFormProps.filterType');
        var isValidFilter = 'activity_amenity_type' !== filterType && 'activity_space_type' !== filterType;
        var filter = '';
        if (filterText && filterType && isValidFilter) {
          filter = "&".concat(filterType, "=").concat(encodeURIComponent(filterText));
        }
        var locationWithActivity = _extends({}, {
          a: activity
        }, parsedLocation);
        var locationQuery = (0, _url_utils.getQueryString)(locationWithActivity);
        var centerOfMap = parsedLocation.viewport_bbox ? _gmap_utils.default.getCenterFromSearchArr(parsedLocation.viewport_bbox) : '';
        var latLngDateTime = dateTime ? "&availability_interval=".concat(centerOfMap.lat(), ",").concat(centerOfMap.lng(), ",").concat(dateTime) : '';
        window.location.href = "/s/?".concat(locationQuery.toLowerCase()).concat(latLngDateTime).concat(filter).concat(spaceTypePage ? '&gs=1' : '');
      }
    }, {
      key: "dropdownRefs",
      value: function dropdownRefs(ref, path) {
        (0, _lodash.set)(this, path, ref);
        return this[path];
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
          dropdownRefs: this.dropdownRefs,
          submitAction: this.submitForm,
          submitCallback: this.submitFormCb
        }, heroHomePageProps, this.props));
      }
    }]);
    return HOC;
  }(_react.default.Component);
  HOC.propTypes = {
    optional: _propTypes.default.bool
  };
  return HOC;
};
var _default = exports.default = withSearchSubmitHoc;